import { apiClient } from './client';

export interface VCollectProjectUser {
  id: number; vcollect_project_id: number; user_id: number; full_name: string; email: string;
  project_role: string; access_scope: string; status: string; effective_from: string | null; effective_until: string | null;
  granted_at: string; revoked_at: string | null; revoke_reason: string | null;
}

export const PROJECT_ROLE_LABELS: Record<string, string> = {
  owner: 'Owner', manager: 'Project Manager', data_manager: 'Data Manager', meal_officer: 'MEAL Officer',
  form_designer: 'Form Designer', supervisor: 'Supervisor', reviewer: 'Reviewer', analyst: 'Analyst', viewer: 'Viewer',
};

export const vcollectProjectUsersApi = {
  list: (projectId: number) => apiClient.get<{ data: VCollectProjectUser[] }>(`/api/vcollect-projects/${projectId}/users`),
  grant: (projectId: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number } }>(`/api/vcollect-projects/${projectId}/users`, input),
  revoke: (id: number, reason?: string) => apiClient.put<{ data: { id: number; status: string } }>(`/api/vcollect-project-users/${id}/revoke`, { reason }),
};
